export const apiMiddleware = (client) => ({ getState }) => (next) => (action) => {
  if (!client.isApiAction(action)) {
    return next(action);
  }

  const sessionToken = null;
  next(action); // Allow the action to be fired as normal
  return client.call(action, sessionToken);
};